import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DurchgangServiceModule } from '..';
import { DurchgangSorterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    DurchgangServiceModule
  ],
  declarations: [DurchgangSorterComponent],
  exports: [DurchgangSorterComponent],

})
export class DurchgangSorterComponentModule { }
